<div *ngIf="!auth.authUser && initialized">
  <div class="login-cover" [style.background]="bgImage"></div>
  <div class="login-filter" [style.opacity]="bgFilterOpacity"></div>
  <app-signin
    [showConnections]="showSystems"
    [systems]="systems"
    [mode]="loginMode"
  ></app-signin>
</div>
